import React, { useState } from "react";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";
import PanelButtonsColors from "src/Component/PanelButtonsColors";

const PageId = 13;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;

  const DATA_IMAGES = [
    { image: `${baseImageUrl}phone_azul.png`, hex: "#017ABF" },
    { image: `${baseImageUrl}phone_verde.png`, hex: "#239A98" },
    { image: `${baseImageUrl}phone_violeta.png`, hex: "#543286" },
    { image: `${baseImageUrl}phone_rojo.png`, hex: "#890714" },
    { image: `${baseImageUrl}phone_negro.png`, hex: "#080D13" },
  ];

  const [selectedImage, setSelectedImage] = useState(DATA_IMAGES[0]);

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  const handleButtonClick = (color: any) => setSelectedImage(color);

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    title: "White-Label Customization",
    description: `Tailor the platform to align with your brand\nidentity and customer expectations.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`Key Features:<ul>\n<li>Custom Branding: Modify logos, themes, and\nUI elements to match your brand.</li>\n<li>Flexible Integration: Seamlessly incorporate\nplatform capabilities into existing ecosystems.</li>\n<li>Localized Experience: Adapt language,\ncontent, and layout for different markets.</li></ul>`}
      />
    ),
    rightSideComponent: (
      <div style={{ position: "absolute", height: "var(--height-1080)", top: 0, width: "var(--width-1080)" }}>
        <PanelButtonsColors colors={DATA_IMAGES} handleOnClick={handleButtonClick} />
        <img src={selectedImage.image} alt="Selected phone" style={{ width: "var(--width-1739)", right: "var(--height-5)", top: 0 }} />
      </div>
    ),
    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
